import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import PreviewPane from './preview-pane';

/** Two columns need the widest panel; anything narrower starves the form beside the preview. */
const PREVIEW_PANEL_SIZE = 'xl' as const;
type NodePreviewLayoutProps = {
  preview: ReactNode;
  children: ReactNode;
};
const NodePreviewLayout = t0 => {
  const $ = _c(7);
  const {
    preview,
    children
  } = t0;
  let t1;
  if ($[0] !== preview) {
    t1 = <PreviewPane className="sticky top-[91px]">{preview}</PreviewPane>;
    $[0] = preview;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="min-w-0 md:flex-1">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col-reverse gap-6 md:flex-row">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default NodePreviewLayout;
export type { NodePreviewLayoutProps };
export { PREVIEW_PANEL_SIZE };